module.exports = __webpack_public_path__ + "img/Lage unser Schiffe.55cc16c7.jpg";